/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { Column, ColumnsInterface } from '@irian-ro/util-table';
import { FilterMatchMode } from 'primeng/api';
import { ETransportModifVehicleHistoryVoModel } from './e-transport-modif-vehicle-history-vo.model';

export class ETransportShipmentOrganizerNotificationVo extends JSONable {
  uuid: string | null = null;

  @Column({
    header: 'etransport.shipmentOrganizer.list.uit',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  uit: string | null = null;

  @Column({
    header: 'etransport.shipmentOrganizer.list.declaringCompanyCode',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  declaringCompanyCode: string | null = null;

  @Column({
    header: 'etransport.shipmentOrganizer.list.declaringCompanyName',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  declaringCompanyName: string | null = null;

  @Column({
    header: 'etransport.shipmentOrganizer.list.declaringCompanyReference',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  declaringCompanyReference: string | null = null;

  @Column({
    header: 'etransport.shipmentOrganizer.list.shipmentDate',
    filterType: 'calendar',
    filterMatchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
  })
  shipmentDate: string | null = null;

  @Column({
    header: 'etransport.shipmentOrganizer.list.validUntil',
    filterType: 'calendar',
    filterMatchMode: FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
  })
  validUntil: string | null = null;

  @Column({
    header: 'etransport.shipmentOrganizer.list.shipmentOrganizerCode',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  shipmentOrganizerCode: string | null = null;

  @Column({
    header: 'etransport.shipmentOrganizer.list.shipmentOrganizerName',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  shipmentOrganizerName: string | null = null;

  @Column({
    header: 'etransport.shipmentOrganizer.list.licensePlates',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  licensePlates: string | null = null;

  modifVehicleVOs: ETransportModifVehicleHistoryVoModel[] | null = null;

  @Column({
    header: 'etransport.shipmentOrganizer.list.startLocation',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  startLocation: string | null = null;

  @Column({
    header: 'etransport.shipmentOrganizer.list.endLocation',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  endLocation: string | null = null;

  @Column({
    header: 'etransport.shipmentOrganizer.list.documents',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  documents: string | null = null;

  static _columns: ColumnsInterface[] | undefined = undefined;
}
